import LazyFilePreviewModal from './LazyFilePreviewModal';

export default LazyFilePreviewModal;
export type { IPreviewItem, IPreviewOrigin } from './filePreview.types';
